import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

const FILTER_BTN =
  "inline-flex min-h-[34px] items-center gap-1.5 rounded-[5px] border border-[rgba(98,94,166,0.62)] bg-[rgba(17,12,61,0.52)] px-3 text-[12px] text-[#e5e2ff] hover:border-v2-cyan hover:bg-v2-accent";

export default function V2FilterDropdown({
  label,
  icon: Icon,
  children,
  align = "right",
}) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const onPointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onPointerDown);
    return () => document.removeEventListener("mousedown", onPointerDown);
  }, []);

  return (
    <div className="relative" ref={rootRef}>
      <button
        type="button"
        className={`${FILTER_BTN} ${open ? "border-v2-cyan bg-v2-accent" : ""}`}
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
      >
        {Icon && <Icon size={15} strokeWidth={1.8} />}
        <span>{label}</span>
        <ChevronDown size={15} />
      </button>
      {open && (
        <div
          className={`absolute top-[calc(100%+6px)] z-30 min-w-[220px] rounded-lg border border-v2-border bg-[#1b1754] p-2 shadow-v2-pop ${
            align === "left" ? "left-0" : "right-0"
          }`}
          role="dialog"
        >
          {typeof children === "function" ? children(() => setOpen(false)) : children}
        </div>
      )}
    </div>
  );
}
